import importedStyles from "./NoResultsMessage.module.sass";
import {isWebpSupported} from "react-image-webp/dist/utils";
import NoVideosImage from "../../images/no-videos-illustration-min.png";
import NoVideosImageWebp from "../../images/no-videos-illustration-min.webp";
import Box from "@material-ui/core/Box";
import React from "react";

const NoResultsMessage = () => {
    return (
        <Box className={importedStyles.noVideosMessageContainer}>
            <img
                src={isWebpSupported() ? NoVideosImage : NoVideosImageWebp}
                className={importedStyles.noVideosImage}
                alt={'no videos'}
            />
            <span className={importedStyles.noVideosMessage}>No se encontraron resultados</span>
        </Box>
    );
};

export default NoResultsMessage;
